// This icon file is generated automatically.
var PColumnWidthOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M1.81 1.75H.87a.13.13 0 00-.12.13v10.25c0 .06.06.12.13.12h.93c.07 0 .13-.06.13-.13V1.88a.13.13 0 00-.13-.13zm11.31 0h-.93a.13.13 0 00-.13.13v10.25c0 .06.06.12.13.12h.94c.06 0 .12-.06.12-.13V1.88a.13.13 0 00-.13-.13zm-1.85 5.13l-2-1.57a.11.11 0 00-.18.09v1.04H4.91v-.98c0-.1-.11-.15-.19-.1L2.73 6.95a.11.11 0 000 .18l2 1.57c.07.06.17.01.17-.09V7.56h4.2v.98c0 .1.1.15.18.1l1.99-1.58a.11.11 0 000-.18z", "fill-rule": "nonzero" } }] }, "name": "p-column-width", "theme": "outlined" };
export default PColumnWidthOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PColumnWidthOutlined.js
// module id = 3298
// module chunks = 0